import { render, staticRenderFns } from "./logs.vue?vue&type=template&id=3f2f1f88&"
import script from "./logs.vue?vue&type=script&lang=ts&"
export * from "./logs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "logs.vue"
export default component.exports